import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { EVoyageCarryableType } from './voyageCarryableData'

export enum EBuyType {
  default = -1,
  crew = 1,
  item = 2,
}

export interface IVoyageBuyData {
  type: string
  kind: EBuyType
  cost: number
  // canBuy: boolean
  item: EVoyageCarryableType | null
  isCrew: boolean
}

const _default: IVoyageBuyData = {
  type: 'Default',
  kind: EBuyType.default,
  cost: 99999,
  //canBuy: false,
  item: null,
  isCrew: false,
}

export const dataList: IVoyageBuyData[] = []
export const dataMap: { [key: string]: IVoyageBuyData } = {}
const dataType = 'voyage-buy'
export const get = (name: string) => {
  return entitiesUtils.genericGetData<IVoyageBuyData>(dataType, dataMap, name)
}
const register = (data: Partial<IVoyageBuyData>) => {
  entitiesUtils.genericRegisterData(dataType, data, _default, dataList, dataMap)
}

export function registerAll() {
  register({
    type: 'Crew',
    kind: EBuyType.crew,
    cost: 250,
    isCrew: true,
  })
  register({
    type: 'Fire extinguisher',
    kind: EBuyType.item,
    cost: 100,
    item: EVoyageCarryableType.Extinguisher,
  })
  register({
    type: 'Wrench',
    kind: EBuyType.item,
    cost: 100,
    item: EVoyageCarryableType.Wrench,
  })
  register({
    type: 'Mop',
    kind: EBuyType.item,
    cost: 50,
    item: EVoyageCarryableType.Mop,
  })
  register({
    type: 'Medpack',
    kind: EBuyType.item,
    cost: 200,
    item: EVoyageCarryableType.Medpack,
  })
  register({
    type: 'Battle rifle',
    kind: EBuyType.item,
    cost: 200,
    item: EVoyageCarryableType.BattleRifle,
  })
  register({
    type: 'Torpedo',
    kind: EBuyType.item,
    cost: 50,
    item: EVoyageCarryableType.Torpedo,
  })
}
